export default {
  LOW: 'low',
  AVERAGE: 'average',
  HIGH: 'high',
};
